export function Star({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span data-testid="star-icon" className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2977 3.13248L11.6177 5.77248C11.7977 6.13998 12.2777 6.49248 12.6827 6.55998L15.0752 6.95748C16.6052 7.21248 16.9652 8.32248 15.8627 9.41748L14.0027 11.2775C13.6877 11.5925 13.5152 12.2 13.6127 12.635L14.1452 14.9375C14.5652 16.76 13.5977 17.465 11.9852 16.5125L9.74268 15.185C9.33768 14.945 8.67018 14.945 8.25768 15.185L6.01518 16.5125C4.41018 17.465 3.43518 16.7525 3.85518 14.9375L4.38768 12.635C4.48518 12.2 4.31268 11.5925 3.99768 11.2775L2.13768 9.41748C1.04268 8.32248 1.39518 7.21248 2.92518 6.95748L5.31768 6.55998C5.71518 6.49248 6.19518 6.13998 6.37518 5.77248L7.69518 3.13248C8.41518 1.69998 9.58518 1.69998 10.2977 3.13248Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
